import React, { useState } from "react";
import { Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

const CEissues = () => {
  const [selectedOption, setSelectedOption] = useState("none");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="MajorConcernsContainer">
      {/* Dropdpwn for Community Engagement Issues */}
      <Box className="MajorConcernsAreaBox">
        <Typography className="issues-area-helper">Key Issues In</Typography>

        <FormControl
          sx={{
            width: {
              xs: "100%",
              sm: 300,
            },
          }}
          className="AreaFormControl"
        >
          <Select
            labelId="Area-label"
            id="Area"
            value={selectedOption}
            onChange={handleChange}
            displayEmpty
            className="IssueAreaSelect"
          >
            <MenuItem value="none">
              <em>-- Select an area --</em>
            </MenuItem>
            <MenuItem value="Evinston">Evinston</MenuItem>
            <MenuItem value="Gordon">Gordon</MenuItem>
            <MenuItem value="Hawthorne">Hawthorne</MenuItem>
            <MenuItem value="IslandGrove">Island Grove</MenuItem>
            <MenuItem value="Melrose">Melrose</MenuItem>
            <MenuItem value="Micanopy">Micanopy</MenuItem>
            <MenuItem value="Monteocha">Monteocha</MenuItem>
            <MenuItem value="OrangeHeights">Orange Heights</MenuItem>
            <MenuItem value="Rochelle">Rochelle</MenuItem>
            <MenuItem value="Waldo">Waldo</MenuItem>{" "}
          </Select>
        </FormControl>
      </Box>
      {/* Concerns for selected are to be displayed */}
      <div className="MajorConcernsData">
        {selectedOption === "none" && (
          <Typography variant="body2">
            <p className="ZeroBottomMargin">
              Please select an area from the above dropdown to view community
              engagement concers related to it.
            </p>
          </Typography>
        )}
        {selectedOption === "Evinston" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Address illegal dumping of tires and oil from the neighboring
                county
              </li>
              <li>Improve the park for better community use</li>
              <li>
                Preserve wildflowers by adjusting current mowing practices
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Gordon" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Clarification on whether the Gordon area falls within Monteocha
              </li>
              <li>
                Concerns over agricultural exemptions on property; county
                transparency is needed as a resident’s exemptions were rescinded
              </li>
              <li>
                Voting difficulties in the Gordon area; need to involve the
                Supervisor of Elections
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Hawthorne" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Increase awareness of countywide events and public meetings
              </li>
              <li>
                Frustration with unfulfilled promises from local government
              </li>
              <li>
                Increase engagement between residents and County Commissioners
              </li>
              <li>
                Funding allocation to outlying areas, such as Orange Heights
              </li>
              <li>
                Desire for consistent engagement with the Orange Heights
                community
              </li>
              <li>
                County needs better management and balance of wetlands and
                growth
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "IslandGrove" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Have the county address tire dumping, with tires rolled into a
                ditch
              </li>
              <li>
                Residents want better communication with the county on volunteer
                efforts like trash pickup
              </li>
              <li>Frustrations with high taxes and unclear benefits</li>
              <li>
                Desire to revisit local regulations and special assessments
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Rochelle" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Requesting a historical marker for the schoolhouse on 282</li>
              <li>
                Requesting a historical marker for the Oakridge Cemetery —
                ensuring it is properly placed at an entrance that shows all are
                welcome and buried there
              </li>
              <li>More hurricane preparedness information is requested</li>
              <li>
                More information on building regulations is requested –
                pertaining to wetlands restrictions, acreage minimums, and
                adequate property assessments
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Melrose" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Because Melrose is split across multiple counties, there’s a
                need for better coordination through an interlocal agreement
              </li>
              <li>
                Concerns were raised about property appraisals, especially
                regarding mobile homes and how values are assessed
              </li>
              <li>
                The community wants more transparency and access to appeal
                property valuations and better communication with the Property
                Appraiser’s Office
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Micanopy" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Revise and enhance city landscaping and maintenance efforts
              </li>
              <li>
                Increase funding for community centers to support local programs
              </li>
              <li>
                Idea to create a dog park for community recreation and
                engagement
              </li>
              <li>
                Work with the county to adjust wildflower mowing processes
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Monteocha" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Better communication regarding building permits, zoning
                restrictions, and private property regulations and possible
                softening of county oversight for the following issues:
                <ul>
                  <li>Wetlands restrictions require a 75-ft buffer</li>
                  <li>
                    A minimum of 5 acres is required to build another home on
                    private property
                  </li>
                  <li>Limits on the number of people per acre</li>
                  <li>Family subdivisions on personal property </li>
                  <li>The purpose of impact fees</li>
                </ul>
              </li>
              <li>Requires county-clarification of Monteocha’s city limit</li>
              <li>
                Need for education on how to appeal decisions from the property
                appraiser’s office
              </li>
              <li>
                Desire for progress on the community park development project
                <ul>
                  <li>New request for an expanded gazebo</li>
                  <li>
                    Concerns about senior parking and accessibility to the
                    walking trail
                  </li>
                  <li>
                    Parks & Rec representative confirmed that the project is
                    moving forward
                  </li>
                  <li>
                    A follow-up meeting will be scheduled in Monteocha to
                    introduce the approved plans
                  </li>
                </ul>
                <li>The oak trees in Monteocha must be preserved</li>
                <li>
                  Explore the possibility of Monteocha obtaining a special area
                  overlay plan to be exempt from certain county regulations
                </li>
                <li>
                  Need clearer communication on which department handles what
                </li>
                <li>
                  Request for a follow-up meeting in Monteocha regarding
                  progress with the county plan
                </li>
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "OrangeHeights" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Funding allocation to outlying areas, such as Orange Heights
              </li>
              <li>
                Desire for consistent engagement with the Orange Heights
                community
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Waldo" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Establish fairgrounds to attract families</li>
              <li>
                Promote and improve outdoor activities in Waldo, including Lake
                Alto and the Santa Fe Canal
              </li>
              <li>
                Establish and promote festivals in Waldo, like Swamp Fest, Sweet
                Potato Festival, and the Spring Plant Festival
              </li>
              <li>Overcome hesitancy and build trust in county support</li>
              <li>
                Improve communication about county programs and events for
                residents living outside Waldo’s city limits
              </li>
              <li>
                Strengthen communication and engagement between Waldo, the
                county, and other government entities
              </li>
              <li>Complete the bike trail to Lake Alto</li>
              <li>
                Establish a physical identity for Waldo, such as a mural,
                welcome sign, and slogan
              </li>
              <li>
                Create satellite SFC programs, jobs, certificates, etc., in the
                area
              </li>
              <li>
                Capitalize on Waldo’s position as the gateway to the county
              </li>
              <li>
                Need more third spaces, beyond just markets, for community
                engagement
              </li>
            </ul>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default CEissues;
